export enum SnsUserStatus {
  Active = "active",
  Inactive = "inactive",
  Suspended = "suspended",
}

export interface Device {
  id: string
  user_id: string
  device_token: string
  app_name: string
  app_version: string
  platform: "ios" | "android" | "web" | "browser"
  last_login_at: string
  created_at: string
}

export interface Avatar {
  id: string
  url: string
  key: string
  attachment_type: "image" | "video" | "document"
  metadata: Record<string, unknown> | null
  dimension: Record<string, unknown> | null
  multipart_data: Record<string, unknown> | null
  e_tag: string | null
  created_at: string
  updated_at: string
  is_completed: boolean | null
  thumbnail_url: string | null
}

export interface UserRelation {
  is_follower: boolean
  is_blocking: boolean
  is_blocked: boolean
  followings: number | null
  followers: number | null
  pinned_followings: number | null
}

export interface SnsUser {
  id: string
  display_name: string | null
  wallet_address: string
  bio: string | null
  description: string | null
  status: SnsUserStatus
  user_type: "personal" | "business" | "organization"
  public_key: string
  avatar_id: string | null
  cover_id: string | null
  disabled_notification: boolean
  disabled_searching: boolean
  social_networks: Record<string, unknown> | null
  nft_avatar: Record<string, unknown> | null
  is_online: boolean
  referral_code: string
  created_at: string
  updated_at: string
  deleted_at: string | null
  score_updated_at: string
  avatar: Avatar | null
  cover: Avatar | null
  devices: Device[]
  percentile_score: number | null
  relation: UserRelation
  follower_count: number
  following_count: number
}
